import type { BlogCategory } from '@bulknutrients/bulk-shared-lib/interfaces/Blog';
import { NavigationBar } from '@components/Header/NavigationBar';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { type ReactElement, useRef } from 'react';

export function BlogCategoryNavBar({
  blogCategories,
}: {
  blogCategories: BlogCategory[];
}): ReactElement {
  const router = useRouter();
  const blogNavRef = useRef<HTMLDivElement>(null);

  return (
    <div className="full-bleed mb-8 mt-6">
      <NavigationBar
        id="blogNavBar"
        testid="blog-category-nav-bar"
        ref={blogNavRef}
        scrollTo={`${encodeURIComponent(router.asPath)}`}
      >
        {blogCategories.map((c) => (
          // required to disable drag functionality on Links in order to customise behaviour
          <div
            className={`${router.asPath === c.slug ? 'border-b-4 text-grey-darkest dark:text-grey-mid' : ''} xl:min-w-auto inline-block h-12 cursor-pointer border-green font-secondary text-lg font-bold uppercase leading-none tracking-wider hover:text-green`}
            draggable
            key={c.slug}
            onDragStart={(e) => e.preventDefault()}
          >
            <Link
              prefetch={process.env.NEXT_PUBLIC_PREFETCH === 'true'}
              data-id={c.slug}
              href={c.slug}
              aria-label={c.category}
              className="flex h-12 w-full px-5 py-4 text-center"
            >
              {c.category}
            </Link>
          </div>
        ))}
      </NavigationBar>
    </div>
  );
}
